export default __webpack_public_path__ + "static/media/1170.fc69c565.JPG";